import React, { useState } from "react";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import LabelledOutline from "./general/LabelledOutline";
import { uploadMarketingArticle } from "./api/marketing";

const styles = {
  closeButton: {
    position: "absolute",
    top: "0",
    right: "0",
    "&:hover": {
      cursor: "pointer",
      color: "#F50057",
    },
  },
};

const ARTICLE_TYPES = [
  "blog",
  "cheat-sheet",
  "guide",
  "tutorial",
  "newsletter",
];

function MarketingUploadModal(props) {
  const [type, setType] = useState("blog");
  const [file, setFile] = useState();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const upload = () => {
    if (!file) {
      setError("Please choose a zip file.");
      return;
    }
    setLoading(true);
    setError("");
    uploadMarketingArticle(
      file,
      type,
      () => {
        setLoading(false);
        props.uploadedCallback();
      },
      (error) => {
        setLoading(false);
        setError(error);
      }
    );
  };

  return (
    <Dialog
      onClose={() => props.closeModal(false)}
      open={props.open}
      maxWidth={"sm"}
      fullWidth
    >
      <IconButton
        sx={styles.closeButton}
        onClick={() => props.closeModal(false)}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle>Upload Article</DialogTitle>
      <DialogContent dividers>
        <FormControl size="small" fullWidth>
          {error !== "" && (
            <Box p={1}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}

          <FormControl margin="dense" fullWidth>
            <InputLabel id="marketing-type-label">Type</InputLabel>
            <Select
              labelId="marketing-type-label"
              label="Type"
              value={type}
              onChange={(event) => setType(event.target.value)}
            >
              {ARTICLE_TYPES.map((articleType) => (
                <MenuItem key={articleType} value={articleType}>
                  {articleType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <LabelledOutline label="Zip File">
            {file && <Typography>{file.name}</Typography>}
            <Button variant="text" color="primary" fullWidth component="label">
              choose zip file
              <input
                type="file"
                accept=".zip"
                hidden
                onChange={(event) => setFile(event.target.files[0])}
              />
            </Button>
          </LabelledOutline>

          <Button
            color="primary"
            variant="contained"
            disabled={loading}
            onClick={upload}
            className="dq-mt-5"
          >
            {loading ? <CircularProgress size={24} /> : "Upload"}
          </Button>
        </FormControl>
      </DialogContent>
    </Dialog>
  );
}

export default MarketingUploadModal;
